<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" size="small" @click="exportData">{{ $t('export') }}</vs-button>
      </template>
      <vs-divider></vs-divider>
    </vx-card>
    <vx-card id="callStatisticsDataContainer" :title="$t('call_statistics')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-call-statistics-tab-nav></shared-call-statistics-tab-nav>
      </template>
      <div class="vx-row">
        <div class="vx-col md:w-1/6 sm:w-1/6 w-full call-statistics-filter-column">
          <date-picker v-model="searchParams.date" :model="searchParams.date" :removeDeleteButton="true" :placeholder="$t('reference_date')" class="mb-3"></date-picker>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/6 w-full call-statistics-filter-column">
<!--          <v-select :options="brandOptions" :reduce="label => label.value" :placeholder="$t('all')" v-model="searchParams.brand" class="mb-3" />-->
          <select v-model="searchParams.brand" class="vs-inputx vs-input--input normal md:mb-0 mb-3" >
            <option value="">{{ $t('all') }}</option>
            <option v-for="(option, key) in brandOptions" :key="'brand_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/6 w-full call-statistics-filter-column">
          <vs-button color="success" type="filled" class="w-full" :active="searchParams.type === 'Hourly'" @click.prevent="loadCallStatistics('Hourly')" v-text="$t('time')"></vs-button>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/6 w-full call-statistics-filter-column">
          <vs-button color="success" type="filled" class="w-full" :active="searchParams.type === 'Daily'" @click.prevent="loadCallStatistics('Daily')" v-text="$t('date')"></vs-button>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/6 w-full call-statistics-filter-column">
          <vs-button color="success" type="filled" class="w-full" :active="searchParams.type === 'Monthly'" @click.prevent="loadCallStatistics('Monthly')" v-text="$t('month')"></vs-button>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/6 w-full call-statistics-filter-column">
          <vs-button color="success" type="filled" class="w-full" :active="searchParams.type === 'MonthlyHourly'" @click.prevent="loadCallStatistics('MonthlyHourly')" v-text="$t('hour_monthly')"></vs-button>
        </div>
      </div>
      <template v-if="loadData">
        <template v-if="searchParams.type === 'Hourly' || searchParams.type === 'MonthlyHourly'">
          <div class="vs-component vs-con-table hoverFlat vs-table-primary">
            <div class="con-tablex vs-table--content">
              <div class="vs-con-tbody vs-table--tbody ">
                <table class="vs-table vs-table--tbody-table">
                  <thead class="vs-table--thead">
                    <tr>
                      <th colspan="1" rowspan="1"></th>
                      <th v-for="n in 24" v-bind:key="n" v-text="n"></th>
                    </tr>
                  </thead>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('outgoing_calls')"></td>
                    <td v-for="n in 24" v-bind:key="n" v-text="datas.outbound[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('outgoing_calls_answered')"></td>
                    <td v-for="n in 24" v-bind:key="n" v-text="datas.outbound_answered[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('rate')"></td>
                    <td v-for="n in 24" v-bind:key="n" :data-tr-title="n">
                      <template v-if="datas.outbound_answered[n] === 0">
                        00.00%
                      </template>
                      <template v-else>
                        {{ ((datas.outbound_answered[n] / datas.outbound[n]) * 100).toFixed(2) }}%
                      </template>
                    </td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" colspan="25"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('incoming_calls')"></td>
                    <td v-for="n in 24" v-bind:key="n" v-text="datas.inbound[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('incoming_calls_answered')"></td>
                    <td v-for="n in 24" v-bind:key="n" v-text="datas.inbound_answered[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('rate')"></td>
                    <td v-for="n in 24" v-bind:key="n" :data-tr-title="n">
                      <template v-if="datas.inbound_answered[n] === 0">
                        00.00%
                      </template>
                      <template v-else>
                        {{ ((datas.inbound_answered[n] / datas.inbound[n]) * 100).toFixed(2) }}%
                      </template>
                    </td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" colspan="25"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('sum')"></td>
                    <td v-for="n in 24" v-bind:key="n" v-text="datas.outbound[n] + datas.inbound[n]" :data-tr-title="n"></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="searchParams.type === 'Daily'">
          <div class="vs-component vs-con-table hoverFlat vs-table-primary">
            <div class="con-tablex vs-table--content">
              <div class="vs-con-tbody vs-table--tbody ">
                <table class="vs-table vs-table--tbody-table">
                  <thead class="vs-table--thead">
                    <tr>
                      <th colspan="1" rowspan="1"></th>
                      <th v-for="n in days" v-bind:key="n" v-text="n"></th>
                    </tr>
                  </thead>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('outgoing_calls')"></td>
                    <td v-for="n in days" v-bind:key="n" v-text="datas.outbound[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('outgoing_calls_answered')"></td>
                    <td v-for="n in days" v-bind:key="n" v-text="datas.outbound_answered[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('rate')"></td>
                    <td v-for="n in days" v-bind:key="n" :data-tr-title="n">
                      <template v-if="datas.outbound_answered[n] === 0">
                        00.00%
                      </template>
                      <template v-else>
                        {{ ((datas.outbound_answered[n] / datas.outbound[n]) * 100).toFixed(2) }}%
                      </template>
                    </td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" :colspan="days + 1"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('incoming_calls')"></td>
                    <td v-for="n in days" v-bind:key="n" v-text="datas.inbound[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('incoming_calls_answered')"></td>
                    <td v-for="n in days" v-bind:key="n" v-text="datas.inbound_answered[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('rate')"></td>
                    <td v-for="n in days" v-bind:key="n" :data-tr-title="n">
                      <template v-if="datas.inbound_answered[n] === 0">
                        00.00%
                      </template>
                      <template v-else>
                        {{ ((datas.inbound_answered[n] / datas.inbound[n]) * 100).toFixed(2) }}%
                      </template>
                    </td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" :colspan="days + 1"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('sum')"></td>
                    <td v-for="n in days" v-bind:key="n" v-text="datas.outbound[n] + datas.inbound[n]" :data-tr-title="n"></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="searchParams.type === 'Monthly'">
          <div class="vs-component vs-con-table hoverFlat vs-table-primary">
            <div class="con-tablex vs-table--content">
              <div class="vs-con-tbody vs-table--tbody ">
                <table class="vs-table vs-table--tbody-table">
                  <thead class="vs-table--thead">
                    <tr>
                      <th colspan="1" rowspan="1"></th>
                      <th v-for="n in 12" v-bind:key="n" v-text="n"></th>
                    </tr>
                  </thead>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('outgoing_calls')"></td>
                    <td v-for="n in 12" v-bind:key="n" v-text="datas.outbound[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('outgoing_calls_answered')"></td>
                    <td v-for="n in 12" v-bind:key="n" v-text="datas.outbound_answered[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('rate')"></td>
                    <td v-for="n in 12" v-bind:key="n" :data-tr-title="n">
                      <template v-if="datas.outbound_answered[n] === 0">
                        00.00%
                      </template>
                      <template v-else>
                        {{ ((datas.outbound_answered[n] / datas.outbound[n]) * 100).toFixed(2) }}%
                      </template>
                    </td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" :colspan="13"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('incoming_calls')"></td>
                    <td v-for="n in 12" v-bind:key="n" v-text="datas.inbound[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('incoming_calls_answered')"></td>
                    <td v-for="n in 12" v-bind:key="n" v-text="datas.inbound_answered[n]" :data-tr-title="n"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('rate')"></td>
                    <td v-for="n in 12" v-bind:key="n" :data-tr-title="n">
                      <template v-if="datas.inbound_answered[n] === 0">
                        00.00%
                      </template>
                      <template v-else>
                        {{ ((datas.inbound_answered[n] / datas.inbound[n]) * 100).toFixed(2) }}%
                      </template>
                    </td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" :colspan="13"></td>
                  </tr>
                  <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                    <td class="td vs-table--td" v-text="$t('sum')"></td>
                    <td v-for="n in 12" v-bind:key="n" v-text="datas.outbound[n] + datas.inbound[n]" :data-tr-title="n"></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </template>
      </template>
    </vx-card>
  </div>
</template>

<script>
import SharedCallStatisticsTabNav from '@/views/Shared/CallStatistics/TabNav'
import DatePicker from '@/components/form-inputs/DatePicker'
import CallStatistics from '@/models/CallStatistics'

export default {
  name: 'User.CallStatistics.CallStatistics',
  components: {
    SharedCallStatisticsTabNav,
    DatePicker
  },
  data () {
    return {
      searchParams: {
        date: typeof this.$route.query.date !== 'undefined' ? this.$route.query.date : this.$momentHelper.getCurrentDate(),
        type: typeof this.$route.query.type !== 'undefined' ? this.$route.query.type : 'Hourly',
        brand: typeof this.$route.query.brand !== 'undefined' ? this.$route.query.brand : ''
      },
      companyId: this.$store.getters.userInfo.company.id,
      brandOptions: [],
      datas: {},
      loadData: false,
      days: 0
    }
  },
  mounted () {
    this.loadCallStatistics(this.searchParams.type)
  },
  methods: {
    async loadCallStatistics (type) {
      this.$vs.loading({container: '#callStatisticsDataContainer'})

      this.searchParams.type = type
      this.$router.replace({ query: { ...this.searchParams } })
      const response = await CallStatistics.findAll({ ...this.searchParams })
      this.datas = response.data.results
      this.brandOptions = response.data.brandOptions
      if (type === 'Daily') {
        this.days = response.data.filter.days
      }

      this.loadData = true
      this.$vs.loading.close('#callStatisticsDataContainer > .con-vs-loading')
    },
    async exportData () {
      this.$store.dispatch('setIsMainTableLoading', true)

      const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
      await CallStatistics.export({ ...this.searchParams, companyId: this.companyId, language, export: true })

      this.$store.dispatch('setIsMainTableLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  #callStatisticsDataContainer {
    table {
      thead,
      tbody {
        tr {
          td,
          th {
            &:nth-child(1) {
              min-width: 100px;
            }
          }
        }
      }
    }
  }
  [active].vs-button-filled  {
    background-color: #17a596 !important;
  }
</style>
